import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroCarousel from './components/HeroCarousel';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestUpdate from './components/LatestUpdate';
import { allMovies } from '@/mocks/movies';

export default function Home() {
  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '窝窝影院 - 免费在线观看、免费影视，免费高清视频免费追剧',
    description:
      '窝窝影院提供免费在线观看、免费影视资源，免费高清视频，免费追剧，最新电影电视剧大全不缓冲，无广告全部免费，每日更新精彩内容。',
    url: 'https://www.wowocinema.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '窝窝影院',
      url: 'https://www.wowocinema.com/',
    },
    about: {
      '@type': 'Organization',
      name: '窝窝影院',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaOrg)}</script>
      <Navbar />
      <ScrollToTop />
      <main>
        <HeroCarousel movies={allMovies} />
        <CategoryNav />
        <HotRanking movies={allMovies} />
        <LatestUpdate movies={allMovies} />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-950">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-lg md:text-xl font-heading font-bold text-white mb-4">
              为什么选择窝窝影院？
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
              {[
                { icon: 'ri-film-line', title: '海量资源', desc: '电影、电视剧、综艺、动漫全覆盖，每日更新' },
                { icon: 'ri-4k-line', title: '高清画质', desc: '1080P高清播放，视觉体验不打折' },
                { icon: 'ri-speed-up-line', title: '极速播放', desc: '先进CDN加速，播放不缓冲不卡顿' },
                { icon: 'ri-advertisement-line', title: '零广告', desc: '纯净观影体验，全程无广告打扰' },
              ].map((item, idx) => (
                <div key={idx} className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-lg bg-primary-500/20 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-primary-400 text-2xl`}></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}